import { useContext, useEffect } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useHasSoftPull } from '~/contexts/FinanceAndTradeContext';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';

export default function useClearFinanceFilters() {
  const isInExperiment = useCheckExperimentBucket(
    'srp-tile-unlock-monthly',
    'experiment'
  );
  const hasValidSoftPull = useHasSoftPull();
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const hasFinanceFilter = Boolean(appliedFilters?.finance);

  useEffect(() => {
    if (!hasValidSoftPull && hasFinanceFilter && isInExperiment) {
      updateRangeFilter({ filterKey: 'finance', value: {} });
    }
  }, [hasFinanceFilter, hasValidSoftPull, isInExperiment, updateRangeFilter]);
}
